import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { DisplayConfiguration } from './DisplayConfiguration.js';
import { pickDataAttributes } from '../../../utils/pickDataAttributes.js';
var styles = Object.freeze([{
  margin: '0 auto',
  maxWidth: '744px',
  width: '100%'
}]);

var DisplayMaxWidthMedium = function DisplayMaxWidthMedium(props) {
  var dataAttributes = pickDataAttributes(props, 'display-max-width-medium');
  return /*#__PURE__*/React.createElement(DisplayConfiguration, _extends({}, props, {
    styles: styles
  }, dataAttributes));
};

DisplayMaxWidthMedium.displayName = "DisplayMaxWidthMedium";
export { DisplayMaxWidthMedium };